import React, { Component, PropTypes } from 'react';
import { DropDownMenu, TextField } from 'material-ui';

class Suggest extends Component {
  state = {
    endpoint: null,
    hintText: null,
    data: [],
    userId: 0,
    closed: true
  };

  onChangeState(ev) {
    let token = this.refs.inputField.getValue();

    if (token.length < 3 && isNaN(parseInt(token, 10))) {
      this.setState({ closed: true });
      return null;
    }

    this.setState({ closed: false });

    return SteelCompass.call(
      this.props.endpoint,
      'suggest',
      { token: token },
      response => {
        if (response.isError) {
          console.log('Ohmy!', response.errMsg);
        } else {
          this.setState({ data: response.data });
        }
      }
    );
  }

  getValue() {
    // return this.refs.inputField.getValue();
    return this.state.data.length == 1
      ? this.state.data[0].id
      : this.state.userId ? this.state.userId : null;
  }

  pickSuggestion(row) {
    this.state.userId = row.id;
    this.refs.inputField.setValue(row.caption);
    this.setState({ closed: true });
  }

  render() {
    let items = [];

    for (var i in this.state.data) {
      let row = this.state.data[i];
      items.push(
        <div
          style={{ padding: '3px 5px', cursor: 'pointer', lineHeight: '100%' }}
          rowId={row.id}
          onClick={this.pickSuggestion.bind(this, row)}
        >
          <div>{row.caption}</div>
          <div style={{ fontSize: '70%' }}>
            {row.descr[0] + ', ' + row.descr[1] + ', ' + row.descr[2]}
          </div>
        </div>
      );
    }

    if (this.state.closed) {
      items = [];
    }

    return (
      <div style={{ zIndex: 3, position: 'relative' }}>
        <TextField
          fullWidth={true}
          ref="inputField"
          hintText={this.props.hintText}
          onChange={this.onChangeState.bind(this)}
        />
        <div
          style={{
            position: 'absolute',
            border: '1px solid #bbb',
            backgroundColor: '#fff'
          }}
        >
          {items}
        </div>
      </div>
    );
  }
}

export default Suggest;



// WEBPACK FOOTER //
// ./src/js/components/Suggest.js